import type { BaseIconProps } from "@/assets/icons/utils";
import type { FC } from "react";

type IconSplitViewProps = BaseIconProps & {
    isActive?: boolean;
};

/**
 * Split view icon with optional filled left panel to indicate active state.
 * When isActive is true, the left panel is filled.
 */
export const IconSplitView: FC<IconSplitViewProps> = ({ size, isActive = false, className, ...props }) => {
    const sizeMap = { sm: 16, base: 20, lg: 24 };
    const numericSize = sizeMap[size];

    return (
        <svg
            className={className}
            width={numericSize}
            height={numericSize}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            {/* Left panel fill when active */}
            {isActive && <rect x="3.5" y="5.5" width="5.5" height="13" fill="currentColor" />}
            {/* Original split icon paths */}
            <path
                d="M12 2.75V21.25M8.25 4.75H2.75V19.25H8.25M15.75 19.25H21.25V4.75H15.75"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="square"
            />
        </svg>
    );
};
